<template>
	<div>
		<el-dialog :visible.sync="showdialog" :title="dialogtitle" :width="width" :append-to-body="true"
		 :close-on-click-modal="false" :destroy-on-close="true">
			<div class="savefeelist">
				<div style="height:100px;text-align:center;">
					<el-form :inline="true" class="demo-form-inline" size="mini">
						<el-form-item :label="feelist_lang.p_name">
							<el-input type="text" v-model="p_name" style="width:200px;"></el-input>
						</el-form-item>
					</el-form>
				</div>
				<el-row>
					<el-col :span="11" style="color:transparent">1</el-col>
					<el-col :span="8">
						<el-button type="success" size="mini" @click="save">{{$lang.label.public.sure}}</el-button>
						<el-button size="mini" @click="showdialog=false" style="margin-left:10px">{{$lang.label.public.cancel}}</el-button>
					</el-col>
				</el-row>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	components: {
		
	},
	props: {
		
	},
	data(){
		return{
			showdialog:false,
			dialogtitle:'',
			width:'500px',
			feelist_lang:{},
			feelist:[],
			p_name:'',
			p_sys:'',
			divclass:'savefeelist'
		}
	},
	mounted() {
		
	},
	methods:{
		init(param){
			//传费用明细
			if(param.feelist!=undefined)
				this.feelist=param.feelist;
			
			if(param.p_sys!=undefined)
				this.p_sys=param.p_sys;
			if(param.dialogtitle!=undefined)
				this.dialogtitle=param.dialogtitle;
			this.showdialog=true;
			var that=this;
			this.$tool.loading(this.$lang.label.public.loading, this.divclass);
			this.$public.GetLanguageByMode('feelist',this).then(res=>{
				this.$tool.loadingclose();
				if(res.state=='1'){
					that.feelist_lang=that.$lang.label.feelist;
					if(that.feelist_lang[param.dialogtitle]!=undefined)
						that.dialogtitle = that.feelist_lang[param.dialogtitle];
				}
			});
		},
		save(){
			if(this.p_name==''){
				this.$tool.message(this.feelist_lang.p_nameempty, 0);
				return false;
			}
			if(this.feelist.length==0){
				this.$tool.message(this.feelist_lang.feelistempty, 0);
				return false;
			}
			var paraminfo={
				p_sys:this.p_sys,
				p_name:this.p_name,
				feelist:this.feelist,
				token:localStorage.getItem('token'),
				domain:this.$apiprototype.WebServer
			}
			this.$tool.loading(this.$lang.label.public.saving, this.divclass);
			this.$apipost.post.SaveFeelistTemp({ paraminfo: paraminfo}).then(res => {
				this.$tool.loadingclose();
				if(res.state=='1'){
					this.$tool.message(this.$lang.label.public.savesuccess);
					this.showdialog=false;
				}
				else
				{
					if(this.feelist_lang[res.errorcode]!=undefined)
						this.$tool.message(this.feelist_lang[res.errorcode], 0);
					else if(this.$lang.label.public[res.errorcode]!=undefined)
						this.$tool.message(this.$lang.label.public[res.errorcode], 0);
					else
						this.$tool.message(this.message, 0);	
				}	
			});
		}
	}
}
</script>

<style>
</style>